"use strict";
import { formatEther } from "@ethersproject/units";
import { useUSDPrice } from "hooks/useUSDPrice";
import useNativeCurrency from "lib/hooks/useNativeCurrency";
import tryParseCurrencyAmount from "lib/utils/tryParseCurrencyAmount";
import { UniverseChainId } from "uniswap/src/types/chains";
export const useNativeUsdPrice = (chainId = UniverseChainId.Mainnet) => {
  const nativeCurrency = useNativeCurrency(chainId);
  const parsedAmount = tryParseCurrencyAmount("1", nativeCurrency);
  const usdcValue = useUSDPrice(parsedAmount)?.data ?? 0;
  return usdcValue;
};
export function useUsdPriceofNftAsset(asset) {
  const fetchedPriceData = useNativeUsdPrice();
  return fetchedPriceData && asset?.priceInfo?.ETHPrice ? (parseFloat(formatEther(asset?.priceInfo?.ETHPrice)) * fetchedPriceData).toString() : "";
}
